<template>
  <div class="services_page">
    <div class="headline -page">
      <h1 class="headline_title title-fade">Флористическое<br/> <span>оформление</span></h1>
      <p class="headline_text subtitle-fade">Счастье в самом расцвете</p>
      <div class="arrow-fade">
        <div class="headline_arrow"></div>
      </div>
    </div>
    <div class="image-fade first">
      <div class="page_big-image jarallax" data-jarallax data-speed="-0.05" data-jarallax-element="50">
        <img class="jarallax-img" src="/src/assets/img/f1.jpg" alt="Флористическое оформление">
      </div>
    </div>
    <div class="page_content">
      <div class="lines">
        <div class="lines_block"></div>
        <div class="lines_block"></div>
      </div>
      <div class="waypoint" v-waypoint="{ active: true, callback: onWaypoint}">
        <div class="page_block left-title padding">
          <p>КОНЦЕПЦИЯ СВАДЬБЫ</p>
          <div class="page_block-number numeric jarallax" data-jarallax-element="-40">01</div>
        </div>
        <div class="page_block right padding mobile-small-padding">
          <p>Подготовка к свадьбе это долгий, но не такой тяжелый путь,
            как многим кажется. Конечно, если вам в этом помогают настоящие профессионалы.
            Создание гармоничной свадебной
            концепции — это важнейшая задача, которая станет основой общего
            настроения торжественной церемонии. Именно в
            этот момент наша команда вместе с вами
            продумывает все детали, сценарий и цветочное оформление. Что вам
            ближе: роскошная церемония с торжественным оркестром
            или уютный семейный праздник? Решать вам.</p>
        </div>
        <div class="page_block center quote">
          <p>Наши профессионалы разрабатывают концепцию сразу
            в нескольких вариантах, что позволяет вам выбирать наиболее
            близкий стиль для свадебной церемонии.
            Для каждого специалиста нашей команды будет честью воплотить
            ваше любое представление об идеальной свадьбе.</p>
        </div>
      </div>
    </div>
    <div class="waypoint img" v-waypoint="{ active: true, callback: onWaypoint}">
      <div class="page_big-image jarallax" data-jarallax data-speed="-0.05" data-jarallax-element="50">
        <img class="jarallax-img" src="/src/assets/img/f2.jpg" alt="Флористическое оформление">
      </div>
    </div>

    <div class="page_content">
      <div class="lines">
        <div class="lines_block"></div>
        <div class="lines_block"></div>
      </div>
      <div class="waypoint" v-waypoint="{ active: true, callback: onWaypoint}">
        <div class="page_block right-title padding">
          <p>ДЛЯ НЕЁ</p>
          <div class="page_block-number numeric jarallax" data-jarallax-element="-40">02</div>
        </div>
        <div class="page_block right padding mobile-small-padding">
          <p>Влюбленная девушка и&nbsp;великолепные цветы&nbsp;&mdash; яркое сочетание,
            к&nbsp;которому прибегают невесты в&nbsp;особенный для себя день. Умело подобранный
            букет гармонирует с&nbsp;платьем, дополняет образ и&nbsp;завораживает гостей.
            Замечательной особенностью является&nbsp;то, что в&nbsp;него могут входить
            любые цветы: розы, тюльпаны, лилии или&nbsp;те, что больше всего нравятся невесте. </p>
          <p>Стоит довериться профессиональном флористу, чтобы учесть многие факторы&nbsp;&mdash;
            время года и&nbsp;температуру, подходит&nbsp;ли венок под длинные волосы или
            короткие. Стоимость букетов, композиций и&nbsp;бюджета на&nbsp;оформление залов
            мы&nbsp;обсуждаем с&nbsp;каждым клиентом индивидуально.</p>
        </div>
      </div>
    </div>

    <div class="page_content">
      <div class="lines">
        <div class="lines_block"></div>
        <div class="lines_block"></div>
      </div>
      <div class="waypoint" v-waypoint="{ active: true, callback: onWaypoint}">
        <div class="page_block left-title padding">
          <p>ДЛЯ НЕГО</p>
          <div class="page_block-number numeric jarallax" data-jarallax-element="-40">03</div>
        </div>
        <div class="page_block right padding mobile-small-padding">
          <p>Если в&nbsp;день свадьбы у&nbsp;невесты есть её&nbsp;букет,
            то&nbsp;украшением костюма жениха служит бутоньерка или цветок
            в&nbsp;петлице. В&nbsp;день бракосочетания, влюбленная девушка
            прикалывает бутоньерку своему избраннику в&nbsp;знак искренней и&nbsp;вечной любви.</p>
        </div>
        <div class="page_block center quote">
          <p>Строгих правил по&nbsp;выбору бутоньерки нет&nbsp;&mdash; главное,
            чтобы она была в&nbsp;тех&nbsp;же оттенках, что и&nbsp;букет невесты.</p>
        </div>
        <div class="page_block right mobile-small-padding">
          <p>Но&nbsp;куда&nbsp;же без друзей жениха. Как и&nbsp;подружкам невесты,
            им&nbsp;тоже выпадает честь носить украшения из&nbsp;цветов, похожие
            на&nbsp;бутоньерку будущего мужа. Мы&nbsp;знаем много подсказок и&nbsp;
            тонкостей по&nbsp;созданию свадебных бутоньерок, и&nbsp;будем рады
            поделиться ими с&nbsp;вами, помогая в&nbsp;подготовке к&nbsp;торжественному дню.</p>
        </div>
      </div>
    </div>

    <div class="waypoint img" v-waypoint="{ active: true, callback: onWaypoint}">
      <div class="page_big-image jarallax" data-jarallax data-jarallax-element="50">
        <img class="jarallax-img" src="/src/assets/img/f3.jpg" alt="Флористическое оформление">
      </div>
    </div>

    <div class="page_content">
      <div class="lines">
        <div class="lines_block"></div>
        <div class="lines_block"></div>
      </div>
      <div class="waypoint" v-waypoint="{ active: true, callback: onWaypoint}">
        <div class="page_block right-title padding">
          <p>ДЛЯ ГОСТЕЙ</p>
          <div class="page_block-number numeric jarallax" data-jarallax-element="-40">04</div>
        </div>
        <div class="page_block right padding mobile-small-padding">
          <p>Если вам хочется выделить некоторых гостей в&nbsp;особую группу,
            то&nbsp;вы&nbsp;можете заказать для них бутоньерки. Согласно этикету,
            неженатые мужчины и&nbsp;незамужние девушки прикалывают данное украшение
            с&nbsp;левой стороны, тогда как остальные&nbsp;&mdash; справа. Важно
            заметить, что такие бутоньерки обычно создаются миниатюрными
            и&nbsp;не&nbsp;должны затмевать наряды виновников торжества. Для девушек
            также можно рассмотреть вариант с&nbsp;браслетами из&nbsp;цветов на&nbsp;руку,
            на&nbsp;левую или правую&nbsp;&mdash; опять&nbsp;же, в&nbsp;зависимости
            от&nbsp;семейного положения каждой из&nbsp;них. Стоит добавить, что лучше
            выбирать &laquo;проверенные&raquo; цветы, избегая аллергии у&nbsp;гостей.</p>
        </div>
      </div>
    </div>

    <div class="page_content">
      <div class="lines">
        <div class="lines_block"></div>
        <div class="lines_block"></div>
      </div>
      <div class="waypoint" v-waypoint="{ active: true, callback: onWaypoint}">
        <div class="page_block left-title padding">
          <p>ЕДИНОЕ ОФОРМЛЕНИЕ</p>
          <div class="page_block-number numeric jarallax" data-jarallax-element="-40">05</div>
        </div>
        <div class="page_block right padding mobile-small-padding">
          <p>Центральное место свадебного торжества&nbsp;&mdash; стол молодоженов.
            Его оформление это прекрасная возможность выделить часть помещения, в&nbsp;которой
            будут находиться жених и&nbsp;невеста, от&nbsp;остальных гостей. Уместным станет
            пышное оформление стульев, выигрышный цвет текстиля, безукоризненные цветочные
            композиции (главное, чтобы они гармонировали с&nbsp;оттенками платья и&nbsp;костюма
            молодоженов).</p>
          <p>Команда свадебного агентства Людмилы Арчуковой &laquo;Антуриум&raquo; ручается,
            что ваш день свадьбы станет одним из&nbsp;самых ярких воспоминаний не&nbsp;только
            в&nbsp;жизни новой семьи, но&nbsp;и&nbsp;всех гостей.</p>
        </div>
        <div class="page_block center quote">
          <p>Чтобы обсудить все детали, пожалуйста, просто оставьте нам ваши контактные
            данные&nbsp;&mdash;
            мы&nbsp;с&nbsp;радостью свяжемся с&nbsp;вами.</p>
        </div>
      </div>
    </div>
    <Form />
  </div>
</template>

<script>
import Form from 'components/form/Form';
import { onWaypoint, parallax } from 'src/mixins';

export default {
  mixins: [onWaypoint, parallax],
  components: {
    Form,
  },
};
</script>



// WEBPACK FOOTER //
// src/components/services/Floristic.vue